/**
 * @Author：zsj
 * @Date：2022/03/08
 */
import { Routes, Route } from 'react-router-dom';
import React from 'react';

import { page404, defaultPage, loginPage } from './index'

const NoPermission = React.lazy(() => import("@/pages/common/no-permission"));

const renderRoute = (routes, extraProps) => {
    if (!routes || !routes.length) {
        return null
    }

    return routes.map((route, i) => {
        let Element = null
        if (route.component) {
            Element = route.component
        }
        if (route.render && typeof route.render === 'function') {
            Element = route.render
        }

        return (
            <Route key={route.key || i}
                   path={route.path}
                   exact={route.exact}
                   element={<Element {...extraProps} />}
            >
                {renderRoute(route.routes)}
            </Route>
        )
    })
}

const getPermissionMap = (routerArr = []) => {
    const retMap = {}
    const forEachArr = arr => {
        arr.forEach(i => {
            retMap[i.id] = i;
            if (i.routes) {
                forEachArr(i.routes)
            }
        })

    }
    forEachArr(routerArr)
    return retMap
}

function renderRoutes(routes, routerArr = [], extraProps, switchProps) {
    const permissionMap = getPermissionMap(routerArr)
    if (!routes) {
        return null
    }

    if (!extraProps) {
        extraProps = {};
    }

    if (!switchProps) {
        switchProps = {};
    }

    const retRouteArr = [page404, defaultPage, loginPage]

    const forEachRoutes = (arr, fatherRoute) => {
        arr.forEach(i => {
            const tempRoute = { ...i }, subRoutes = [...i.routes || []]
            tempRoute.component = permissionMap[i.id] ? tempRoute.component : NoPermission // 权限控制
            tempRoute.path = fatherRoute && fatherRoute.path ? `${fatherRoute.path}/${tempRoute.path}` : tempRoute.path

            if (subRoutes.length) {
                forEachRoutes(subRoutes, tempRoute)
            }

            if (tempRoute.isSub) {
                fatherRoute && fatherRoute.routes.push(tempRoute)
            } else {
                // 没有渲染组件--->不渲染路由
                tempRoute.component && retRouteArr.push(tempRoute)
            }

        })
    }

    forEachRoutes(routes)
    return (
        <Routes {...switchProps}>
            {
                renderRoute(retRouteArr, extraProps)
            }
        </Routes>
    )
}

export default renderRoutes;
